function IconNotFocused({ size = "28" }: { size?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M10.472 14C7.25084 14 4.63867 10.2212 4.63867 7V5.83333C4.63867 2.61217 7.25084 0 10.472 0C13.6932 0 16.3053 2.61217 16.3053 5.83333V7C16.3053 10.2212 13.6932 14 10.472 14Z"
          fill="white"
        />
        <path
          d="M13.9707 22.1667C13.9707 20.1857 14.6765 18.3703 15.8502 16.9563C14.2799 16.6028 12.4447 16.3333 10.4707 16.3333C7.1772 16.3333 4.2547 17.0777 2.33437 17.7252C0.915703 18.2035 -0.0292969 19.5393 -0.0292969 21.0362V25.6667H14.7675C14.2624 24.605 13.9707 23.4208 13.9707 22.1667Z"
          fill="white"
        />
        <path
          d="M27.3179 18.6667L25.6682 17.017L22.1682 20.517L18.6682 17.017L17.0186 18.6667L20.5186 22.1667L17.0186 25.6667L18.6682 27.3164L22.1682 23.8164L25.6682 27.3164L27.3179 25.6667L23.8179 22.1667L27.3179 18.6667Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { IconNotFocused };
